import React from "react";
import '../../styles/css/index.css';
import lang from '../../i18/lang';
import img_about from "../../assets/illustration/about.png";

class About extends React.Component{
    render(){
        return (
            <div id="o_nama" ref={this.props.ref_about} className="about-wrapper">
               <div className="about-content">
                   <div className="about-head">
                       <h1>{lang.srb.o_name}</h1>
                       <h3>{lang.srb.section.about.t1}</h3>
                       <h4>{lang.srb.section.about.t2}</h4>
                       <p>{lang.srb.section.about.t3}</p>
                       <p>{lang.srb.section.about.t4}</p>
                       <p>{lang.srb.section.about.t5}</p>
                   </div>
                   <div className="about-sketch">
                       <img src={img_about} alt="Misija i Vizija"/>
                   </div>
               </div>
                <div className="about-bottom-angle">

                </div>
                <div className="about-bottom-square">

                </div>
            </div>
        )
    }
}

export default About;